<template>
    <div>
        <CustomerTrimStats :currentTrimsCount="trims.length" />
        
        <PaginationContainer
                @changedPage="changedPage"
                @changedPageSize="changedPageSize"
        >
            <TrimsTable
                    :trims="trims"
                    :dataFetching="dataFetching"
                    @search="searchTrims"
            ></TrimsTable>
        </PaginationContainer>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import PaginationContainer from "../../components/pagination/PaginationContainer";
    import TrimsTable from "./TrimsTable";
    import CustomerTrimStats from "../../../components/trims/CustomerTrimStats";

    export default {
        name: "TrimsTab",

        components: {
            PaginationContainer,
            TrimsTable,
            CustomerTrimStats
        },

        props: [
            'routeName',
        ],

        data() {
            return {
                myTrimsUserId: null,
                dataFetching: false,
                searchQuery: {},
            }
        },

        computed: {
            ...mapState('authentication', [
                'userId',
            ]),

            ...mapState('pagination', [
                'currentPage',
            ]),

            ...mapState('trims', [
                'trims',
            ]),

        },

        methods: {
            ...mapActions('pagination', [
                'setPage',
            ]),

            ...mapActions('trims', [
                'getTrimsByQuery',
                'savePaginationPageSize',
            ]),

            searchTrims({searchQuery, page}) {
                // use mainParams only if searching by user or customer
                const userId = this.myTrimsUserId;
                const mainParams = { userId };

                // set from the search fields
                this.searchQuery = searchQuery;

                this.dataFetching = true;

                // get and set trims
                this.getTrimsByQuery({ mainParams, searchParams: searchQuery, page })
                    .finally(() => {
                        this.dataFetching = false;
                    });

                this.setPage(page);
            },

            changedPage(page) {
                this.searchTrims({searchQuery: this.searchQuery, page});
            },

            changedPageSize(pageSize) {
                // save pagination params for "trims"
                this.savePaginationPageSize(pageSize);

                this.changedPage(this.currentPage);
            },

        },

        beforeMount() {
            this.myTrimsUserId = this.routeName === 'my-trims' ? this.userId : null;
        },

    }
</script>

<style>

</style>